import React, { useEffect, useRef, useState } from 'react'
import atelierFeaturing from '../../../assets/images/atelierFeaturing.PNG'
import atelierLogo from '../../../assets/images/atelierLogo.png'
// import pinchtozoom from '../../../assets/images/pinchtozoom.png'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import figmaAnimate from '../../../assets/images/figmaAnimate.gif'
import getStartedImage from '../../../assets/images/getStartedImage.gif'
import Footer from '../../Footer/Footer'
import { BiArrowBack } from 'react-icons/bi'

const Fondation = () => {
  const [loading, setLoading] = useState(true)
  // const [showPopupTayaraProject, setShowTayaraProjectPopup] = useState(true)

  useEffect(() => {
    import('./projects.css')
      .then(() => setLoading(false)) // CSS is imported, stop loading
      .catch(() => setLoading(false)) // In case of error, stop loading as well
  }, [])

  const [isLoading, setIsLoading] = useState(true)
  const iframeRef = useRef(null) // Use a ref to access the iframe

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false) // Fallback in case iframe never loads
    }, 12000)

    return () => {
      clearTimeout(timeout) // Clear timeout if iframe loads successfully
      setIsLoading(false)
    }
  }, [])

  // function handleCloseOnboardingTayaraProject() {
  //   setShowTayaraProjectPopup(false)
  // }

  return (
    <div>
      {/* {showPopupTayaraProject && (
        <div
          class="showpopup"
          onClick={(e) => {
            if (e.target !== e.currentTarget) return
            handleCloseOnboardingTayaraProject()
          }}
        >
          <img
            src={pinchtozoom}
            alt="pinch to zoom project images"
            className="NavigationGuide"
          />
          <button onClick={() => handleCloseOnboardingTayaraProject()}>
            Skip
          </button>
        </div>
      )} */}
      {loading ? (
        <div class="spinner-wrap-on-loading">
          <div className="loading-container">
            <img className="logo-on-loading" src={logoNacer} alt="" />
            <div class="spinner-item"></div>
            <div class="spinner-item spinner-item--2"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-black font-sans overflow-hidden">
            <header class="header">
              <a href="https://nacermediouni.vercel.app/">
                <img class="logo" src={logoNacer} alt="" />
              </a>
            </header>
            <div className="absolute flex flex-col z-[9999] top-11 right-6 md:right-12 w-fit h-fit">
              <a
                className=" flex gap-4 items-center text-sm font-bold  text-white hover:text-neutral-500 "
                href="https://nacer-mediouni.netlify.app/works"
              >
                <BiArrowBack size={20} />
                Back to projects
              </a>
              <span className="relative left-10 bottom-3 rotate-90 w-[1px] h-10 bg-[#00ffc6]"></span>
            </div>
            <div className="w-full h-screen bg-[url('/src/assets/images/atelierFeaturing.PNG')] bg-no-repeat bg-cover lg:bg-cover lg:bg-fixed  bg-center ">
              <div className="absolute inset-0 z-10 w-full h-screen bg-black/80 ">
                <div className="w-full h-full flex flex-col items-center justify-end gap-6 pb-[75%] md:pb-[20%]">
                  {/* <h1 className="text-6xl font-extrabold">Tayara</h1> */}
                  <img
                    src={atelierLogo}
                    alt="tayara-project-logo"
                    className=""
                  />

                  <p className="mx-4 lg:mx-[25%] text-base lg:text-xl text-center font-medium ">
                    A website to showcase the agency's architectural services
                    and portfolio
                  </p>
                  <div className="w-full absolute bottom-10">
                    <div class="scd">
                      <div class="chv"></div>
                      <div class="chv"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-slate-50 text-black ">
              <div className="w-full flex flex-col gap-4">
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Role</h1>
                  <span className="text-base">
                    UI/UX Designer & Frontend Engineer
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Settings</h1>
                  <span className="text-base">
                    Freelance project with Emiketic Web Technologies Agency
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Timeline</h1>
                  <span className="text-base">2021</span>
                </div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="w-full flex justify-between items-center flex-wrap gap-4">
                <div className="w-fit">
                  <h1 className="text-3xl md:text-5xl font-extrabold">
                    Atelier
                  </h1>
                  {/* <h1 className="text-base md:text-xl font-extrabold my-2">
                    #1 Most visited Tunisian Classified Marketplace
                  </h1> */}
                </div>
                {/* <a
                  href="https://fondationtunisie.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                >
                  View final product
                </a> */}
              </div>
              <img
                src={atelierFeaturing}
                className="w-full my-10 rounded-3xl border-[1px] border-neutral-100"
                alt="tayara-project-kpis"
              />
              <p className="text-base md:text-lg  font-normal font-sans my-10">
                Atelier specializes in providing comprehensive studies and
                insights into architectural design, offering clients both
                visionary concepts and technical expertise.
              </p>

              <div className="w-full justify-between items-center my-10 md:my-14">
                <h1 className="text-xl md:text-2xl font-extrabold my-4">
                  Role & Project
                </h1>
                <p className="text-base md:text-lg">
                  As a Freelance UI Designer and Frontend Developer contributor
                  for Atelier, I was commissioned to design a digital experience
                  that would authentically reflect the agency's dedication to
                  architectural research and innovation. I collaborated with the
                  Emiketic Agency's design and development team to build the
                  user interface. My contributions included designing the
                  website's interfaces, using <b>Figma</b> and assisting with
                  the implementation of the front-end using
                  <b> Gatsby.js </b> framework.
                </p>
              </div>
              <h1 className="text-xl md:text-2xl font-extrabold my-4">
                Wireframes
              </h1>
              <div className="relative flex justify-center items-center w-[full] h-full">
                {/* Loader with Figma Logo */}
                {isLoading && (
                  <div className="absolute bottom-0  w-full h-[99%]  flex flex-col justify-center items-center bg-black z-50">
                    {/* Figma Logo */}
                    <img
                      src={figmaAnimate}
                      alt="Figma Logo"
                      className="w-34 h-32 mb-4 " // Add a bounce animation to the logo
                    />
                  </div>
                )}

                {/* Figma Embed */}
                <iframe
                  ref={iframeRef} // Attach the ref to the iframe
                  title="work"
                  className="relative w-full bg-white md:w-full h-screen"
                  src="https://embed.figma.com/design/nWnDvb2k9GuS9CLu6hA3bB/atelier?node-id=0-1&embed-host=share"
                  allowFullScreen
                >
                  All the hard work paid off
                </iframe>

                {/* Bottom Bar */}
                <div className="absolute bottom-0 w-full bg-white h-[50px] z-50"></div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <h1 className="text-xl md:text-2xl font-extrabold my-4">
                Prototypes
              </h1>
            </div>

            <div className="relative w-full h-full mt-10">
              <div className="absolute bottom-1 w-full bg-black h-[50px] z-50 "></div>

              <iframe
                title="work"
                className="relative w-full h-[20rem] md:h-screen"
                src="https://embed.figma.com/proto/nWnDvb2k9GuS9CLu6hA3bB/atelier?node-id=967-261&node-type=frame&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=967%3A261&show-proto-sidebar=1&embed-host=share"
                allowfullscreen
              >
                All the hard work paid off
              </iframe>
            </div>

            {/* <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-white text-neutral-600 flex justify-center">
              <a
                href="https://fondationtunisie.org/"
                target="_blank"
                rel="noopener noreferrer"
                className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
              >
                View final product
              </a>
            </div> */}
          </div>
        </>
      )}
      <div className=" bg-black flex flex-col md:flex-row justify-start items-center ">
        <img src={getStartedImage} alt="get started" className="w-[50%]" />
        <div className="w-full h-full gap-10 flex flex-col justify-center items-center md:items-start mx-auto pb-20 md:pb-0">
          <p className="text-3xl lg:text-5xl md:w-[90%] px-[10%] md:px-0 text-center md:text-start font-semibold">
            Want to build remarkable products together?
          </p>
          <a
            href="https://www.linkedin.com/in/nacermediouni/"
            aria-label="Linkedin"
            target="_blank"
            rel="noreferrer"
            className=" text-2xl lg:text-3xl text-[#00ffc6] font-bold underline underline-offset-2 hover:underline-offset-1"
          >
            Let's get strated!
          </a>
        </div>
      </div>

      <div className="  w-full flex flex-col justify-center items-center pt-20 pb-8 px-[10%] md:px-[20%] font-sans bg-white">
        <Footer />
      </div>
    </div>
  )
}

export default Fondation
